module.exports = CONFIG;